/* eslint-disable indent */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { verificationCodeControl } from 'helpers/authControl';
import { useTranslation } from 'react-i18next';
import useField from 'hooks/useField';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { setUser, resendVerificationCode } from 'redux/features/sessionSlice';
import { selectPool } from 'redux/features/poolSlice';
//components/ui
import { Input, FormNotificationError } from 'components';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';

export default function VerificationCodeForm({ setStage, email }) {
  const { t } = useTranslation([
    'accountVerification',
    'signUp',
    'translation',
  ]);
  const [loading, setLoading] = useState(false);
  const verificationCodeField = useField('number');
  const pool = useSelector(selectPool);
  const dispatch = useDispatch();

  const inputFormControl = () => {
    const verificationCode = verificationCodeField.atributes.value;

    verificationCodeControl(verificationCode)
      ? verificationCodeField.actions.onSuccess()
      : verificationCodeField.actions.onError(
          <FormNotificationError
            errorMsg={t('error.incorrectCode', {
              ns: 'accountVerification',
            })}
          />,
        );
  };

  const handleConfirmSignUpError = (err) => {
    const { name } = err;
    console.log('Error: ', err);
    console.log('Nombre del error: ', name);

    if (name === 'ExpiredCodeException') {
      verificationCodeField.actions.onError(
        <FormNotificationError
          errorMsg={t('error.expiredCode', { ns: 'accountVerification' })}
        />,
      );
    }

    if (name === 'CodeMismatchException') {
      verificationCodeField.actions.onError(
        <FormNotificationError
          errorMsg={t('verifyError.incorrectCode', {
            ns: 'accountVerification',
          })}
        />,
      );
    }
  };

  const confirmSignUp = () => {
    const verificationCode = verificationCodeField.atributes.value;
    const user = setUser(email, pool);

    user.confirmRegistration(verificationCode, true, (err, result) => {
      if (err) {
        handleConfirmSignUpError(err);
      } else {
        console.log('Confirm sign up success: ' + JSON.stringify(result));
        setStage('success');
      }
    });
  };

  const onSubmit = (event) => {
    const verificationCode = verificationCodeField.atributes.value;

    event.preventDefault();
    setLoading(true);

    inputFormControl();

    if (verificationCodeControl(verificationCode)) {
      confirmSignUp();
    }

    setLoading(false);
  };

  return (
    <form onSubmit={onSubmit}>
      <Grid container spacing={4}>
        <Input
          label={t('global.verificationCode', { ns: 'translation' })}
          atributes={verificationCodeField.atributes}
        />

        <Grid item container xs={12}>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretched', sm: 'center' }}
            justifyContent={'space-between'}
            width={1}
            maxWidth={600}
            margin={'0 auto'}
          >
            <Box marginBottom={{ xs: 1, sm: 0 }}>
              <Typography
                style={{ display: 'flex', gap: 4 }}
                variant={'subtitle2'}
              >
                {t('verify.didNotReceiveCode', { ns: 'accountVerification' })}
                <Link
                  component={'a'}
                  color={'primary'}
                  to={''}
                  underline={'none'}
                  onClick={() => dispatch(resendVerificationCode(email))}
                >
                  {t('verify.resendCode', { ns: 'accountVerification' })}
                </Link>
              </Typography>
            </Box>
            <Button
              size={'large'}
              style={{ minWidth: 140 }}
              variant={'contained'}
              type={'submit'}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: green[300] }} />
              ) : (
                t('verify.verifyAccount', { ns: 'accountVerification' })
              )}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}

VerificationCodeForm.propTypes = {
  setStage: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
};
